export const findParentByTagName = (element: HTMLElement, tagName: string) => {
    let parent = element;

    while (parent !== null && parent.tagName !== tagName.toUpperCase()) {
        parent = parent.parentNode as HTMLElement;
    }

    return parent;
}